import { useTranslation } from 'react-i18next';
import { useSlate } from 'slate-react';
import { Typography } from 'app/components/ui';
import { useTagNav } from 'app/state/contexts/TagContext';
import { useDeleteFootnote } from 'entities/tag';
import { footnoteSnippet, removeFootnote } from 'slate/extensions/tag';
import { useEditorDocument } from 'app/api/documents/useEditorData';

export const FootnotePanel = () => {
  const { t } = useTranslation(['common', 'tag']);

  const editor = useSlate();
  const { data: pDocument } = useEditorDocument();
  const { selectedFootnoteId, setSelectedFootnoteId } = useTagNav();
  const { mutate: deleteFootnote } = useDeleteFootnote();

  if (!selectedFootnoteId) return null;

  const snippet = footnoteSnippet(editor, selectedFootnoteId) ?? '';

  const handleRemove = () => {
    removeFootnote(editor, selectedFootnoteId);
    deleteFootnote({ id: selectedFootnoteId, documentSuperId: pDocument?.superId });
    setSelectedFootnoteId(null);
  };

  return (
    <section className="p-3 w-100">
      <Typography variant="body-7" fontWeight="semibold">
        {t('tag:footnotes.title')}
      </Typography>
      <Typography variant="body-7" fontWeight="light" style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {snippet}
      </Typography>
      <div className="mt-2">
        <button className="btn btn-secondary" onClick={handleRemove}>
          {t('tag:footnote.remove')}
        </button>
        <button className="btn btn-link" onClick={() => setSelectedFootnoteId(null)}>
          {t('common:cancel')}
        </button>
      </div>
    </section>
  );
};
